import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FIKO_KONTROL_STIL } from './fiko-kontrol-stil';

/**
 * Part Design feature'ı (Pad/Pocket/Dizi/Ayna) için parametrik düzenleme paneli.
 * Fiko3DHizliMenu hizliMenu3DEk üzerinden render edilir; değişiklik anında rebuild eder.
 * Tüm parametreler FikoModellemeYonetici.featureParametreleri'nden gelir (merkezi).
 */
@Component({
  selector: 'fikoyt-feature-hizli-ek',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="fk fk-panel" *ngIf="element && yonetici" style="width:190px;">
    <div class="fk-baslik">
      <span class="fk-bi">{{ tipIkon() }}</span>
      <span class="fk-ad">{{ tipAd() }}</span>
    </div>
    <div class="fk-govde">
      <div class="fk-satir" *ngFor="let p of parametreler(); trackBy: trk">
        <label>{{ p.etiket }}</label>
        <div class="fk-inp">
          <input class="fk-in" type="number" [ngModel]="p.deger" (ngModelChange)="degistir(p.anahtar, $event)" [step]="1" [min]="p.tamSayi ? 1 : 0" />
          <span class="fk-birim" *ngIf="p.birim">{{ p.birim }}</span>
        </div>
      </div>
      <div class="fk-bos" *ngIf="!parametreler().length">Düzenlenebilir parametre yok.</div>
    </div>
    <div class="fk-altbar">
      <button class="fk-btn red fk-btn-genis" (click)="sil()"><span class="fk-bi">🗑</span> Özelliği Sil</button>
    </div>
  </div>
  `,
  styles: [FIKO_KONTROL_STIL, `.fk-bi{font-size:14px;line-height:1;}`]
})
export class FikoFeatureHizliEk {
  @Input() element: any;   // IOzellik
  @Input() yonetici: any;  // FikoModellemeYonetici

  constructor(public CD: ChangeDetectorRef) {}

  trk = (_: number, p: any) => p.anahtar;

  parametreler(): any[] { return this.yonetici?.featureParametreleri(this.element) || []; }

  tipAd(): string {
    return ({ pad: 'Pad', pocket: 'Pocket', shaft: 'Shaft', groove: 'Groove', mirror: 'Ayna', patternDik: 'Doğrusal Dizi', patternDairesel: 'Dairesel Dizi', patternIzgara: 'Izgara Dizi' } as any)[this.element?.tip] || 'Özellik';
  }
  tipIkon(): string {
    return ({ pad: '⬆', pocket: '⬇', shaft: '🌀', groove: '↻', mirror: '🪞', patternDik: '⋯', patternDairesel: '✳', patternIzgara: '▦' } as any)[this.element?.tip] || '◆';
  }

  degistir(anahtar: string, deger: number): void { this.yonetici?.featureParamGuncelle(this.element, anahtar, +deger); this.CD.markForCheck(); }
  sil(): void { this.yonetici?.featureSil(this.element); }
}
